import type { PartialMessages } from "../messages";
import { es } from "./es";

/**
 * Latin American Spanish. Only the handful of places where the Peninsular
 * wording would sound wrong: "vosotros", "ordenador", quotation marks.
 */
export const es419: PartialMessages = {
  ...es,
  "hint.objective": "Adónde van",
  "sidebar.styleTile": "Satelital",
  "sidebar.floors": "Piso (solo cambia tu vista)",
  "sidebar.groundFloor": "Planta baja",
  "sidebar.floorNote": "Las marcas de otros pisos se ven atenuadas.",
  "pin.floor": "Piso",
  "pin.notePlaceholder": "Agrega una nota (p. ej., ventana del tercer piso)",
  "handoff.open": "Abrir en el navegador de esta computadora",
  "handoff.warn":
    "No se lo pases a nadie: al abrirlo se consume. Para eso usa \"Invitar a alguien\".",
  "landing.point2": "Los 13 mapas. Ilustrados o satelitales, y los pisos",
  "landing.tagline2": "con todos los del canal de voz de Discord y explíquenlo juntos.",
  "error.handoffSpent":
    "Ese enlace no funciona. Es de un solo uso y solo para quien lo creó. Para traer a alguien, crea un enlace de invitación desde el mapa.",
};
